/* eslint-disable import/no-extraneous-dependencies */
// routing
import Routes from 'routes';

// project imports
import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
import ThemeCustomization from 'themes';
import DevelopmentTag from 'ui-component/DevelopmentTag';
import AuthenticationProvider from 'hooks/api/authentication/AuthenticationProvider';

// ==============================|| APP ||============================== //

const App = () => (
    <ThemeCustomization>
        <AuthenticationProvider>
            <Locales>
                <NavigationScroll>
                    <Routes />
                    <DevelopmentTag />
                </NavigationScroll>
            </Locales>
        </AuthenticationProvider>
    </ThemeCustomization>
);

export default App;
